import React, { useEffect, useState, useCallback } from "react";
import StickyOffsetHeader from "src/components/Planner/sticky-planner-header/StickyOffsetHeader";

interface ITimelineColumnBaseProps {
    className?: string;
    columnIndex: number;
    columnWidth: number;
    reportHeaderHeight: (height: number) => void;
    headerHeightDeps?: React.DependencyList;
    header: React.ReactNode;
    laneClassName?: string;
    laneStyle?: React.CSSProperties;
    elevatedZIndex?: boolean;
}

const EMPTY_HEADER_HEIGHT_DEPS: React.DependencyList = [];

const TimelineColumnBase = (props: ITimelineColumnBaseProps) => {
    const headerRef = React.useRef<HTMLDivElement>(null);
    const contentRef = React.useRef<HTMLDivElement>(null);
    const headerHeightDeps = props.headerHeightDeps ?? EMPTY_HEADER_HEIGHT_DEPS;
    const [placeholderHeight, setPlaceholderHeight] = useState<number | undefined>(undefined);

    const measureHeight = useCallback(() => {
        if (!contentRef.current) return 0;
        return contentRef.current.clientHeight;
    }, []);

    useEffect(() => {
        const height = measureHeight();
        if (height > 0) {
            setPlaceholderHeight(height);
            props.reportHeaderHeight(height);
        }
    }, [props.reportHeaderHeight, measureHeight, ...headerHeightDeps]);

    return (
        <div
            className={["TimelineColumn", props.className].filter(x => !!x).join(" ")}
            style={{ width: props.columnWidth }}
        >
            <div ref={headerRef} className="timeline-header" style={{ minHeight: placeholderHeight }}>
                <StickyOffsetHeader elevatedZIndex={props.elevatedZIndex}>
                    <div ref={contentRef}>
                        {props.header}
                    </div>
                </StickyOffsetHeader>
            </div>
            <div
                className={["border-right", "lane", props.laneClassName].filter(x => !!x).join(" ")}
                style={{
                    width: props.columnWidth,
                    ...props.laneStyle
                }}
            />
        </div>
    );
};

export default TimelineColumnBase;
